// // frontend/src/pages/LoginPage.tsx
// import React, { useState } from 'react';
// import Header from '../components/Header/Header';
// import Background from '../components/Background/Background';
// import '../styles/LoginPage.css';
// import helixImg from '../assets/helix.png';

// const LoginPage: React.FC = () => {
//   // two phases: 'initial' shows the button; 'phone' shows the input
//   const [phase, setPhase] = useState<'initial' | 'phone'>('initial');

//   return (
//     <>
//       {/* Header remains unchanged */}
//       <Header title='Mitoflux Rx' userName='Innskráning' />

//       {/* Blue-box background */}
//       <Background>
//         <div className='login-box'>
//           {/* subtle helix background */}
//           <img src={helixImg} className='login-helix' alt='Helix Logo' />

//           <div className='login-content'>
//             {/* Swap heading based on phase */}
//             {phase === 'initial' ? (
//               <>
//                 <h2 className='login-heading'>
//                   Hér geta læknar breytt og
//                   <br />
//                   stofnað lyfjaskömmtun rafrænt
//                 </h2>
//                 <button className='login-button' onClick={() => setPhase('phone')}>
//                   Innskráning lækna
//                 </button>
//               </>
//             ) : (
//               <>
//                 <h2 className='login-heading'>Innskráning með rafrænum skilríkjum</h2>
//                 <input className='login-input' type='text' placeholder='Símanúmer' />
//               </>
//             )}
//           </div>
//         </div>
//       </Background>
//     </>
//   );
// };

// export default LoginPage;

//frontend/src/pages/LoginPage.tsx
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const { loginWithRedirect, isLoading, error } = useAuth0();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has('error')) {
      navigate('/login', { replace: true }); // removes ?error=...
    }
  }, [location.search, navigate]);

  return (
    <div style={{ padding: 24 }}>
      <h1>Mitoflux</h1>
      <p>Please sign in to continue.</p>

      {error && <pre style={{ color: 'crimson' }}>{error.message}</pre>}

      <button
        onClick={() =>
          loginWithRedirect({
            authorizationParams: {
              // connection: 'mitoflux-signicat',
              audience: process.env.REACT_APP_AUTH0_AUDIENCE,
              scope: 'openid profile email nin idp-id',
              // prompt: 'login',
              connection: 'Username-Password-Authentication',
            },
          })
        }
        disabled={isLoading}
      >
        {isLoading ? 'Loading…' : 'Log in'}
      </button>

      {/* 👇 DEV ONLY: token verification */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{ marginTop: 24 }}>
          <DebugTokenButton />
        </div>
      )}
    </div>
  );
}

export function DebugTokenButton() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  return (
    <button
      onClick={async () => {
        try {
          const token = await getAccessTokenSilently({
            authorizationParams: {
              audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            },
          });

          const res = await fetch('https://api-staging.mitoflux.is/api/whoami', {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
            },
            credentials: 'include',
          });

          await res.text();
        } catch {
          // debug whoami failed
        }
      }}
      disabled={!isAuthenticated}
    >
      Debug: Call /api/whoami
    </button>
  );
}
